module.exports = __webpack_public_path__ + "components/incentive/static/incentive-mobile-2bb8220e172f467b45a078c6d43fd2d4.png";